export default __webpack_public_path__ + "static/media/Securing Growth Capital for Alternative Finance Companies in the COVID-19 Era.818f7cea.pdf";